'use client';
import { OnbModal } from '@/components/modal';
import OnbDevTools from '@/components/onbDevTools';
import { OnbToast } from '@/components/toast';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { FloatingWhatsApp, theme } from '@repo/ui';
import { sendEventProps, SendNavigatorData } from '@repo/utils';
import { useEffect } from 'react';
import { Provider } from 'react-redux';
import { store } from './store';

export function Providers({ children, nonce }: { children: React.ReactNode; nonce: string }) {
  useEffect(() => {
    SendNavigatorData({
      app: 'onboarding',
      instanceType: process.env.NEXT_PUBLIC_ONB_INSTANCE_TYPE as sendEventProps['instanceType'],
    });
  }, []);
  return (
    <ThemeProvider theme={theme({ nonce })}>
      <CssBaseline />
      <Provider store={store}>
        <OnbModal />
        <OnbToast />
        {children}
        {process.env.NEXT_PUBLIC_ENABLE_DEVTOOLS && <OnbDevTools />}
        {process.env.NEXT_PUBLIC_ONB_INSTANCE_TYPE === 'onb-comercios' && (
          <FloatingWhatsApp
            enable
            buttonTitle="¿Tenés dudas?"
            buttonSubtitle="Atención a comercios​"
            phoneNumber="5491157494024"
          />
        )}
        {process.env.NEXT_PUBLIC_ONB_INSTANCE_TYPE === 'onb-efectivo' && <FloatingWhatsApp enable />}
      </Provider>
    </ThemeProvider>
  );
}
